(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7643],{

/***/ 32126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_pages_unete_JoinRemax__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89139);
/* harmony import */ var _components_pages_unete_Statistic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47070);
/* harmony import */ var _components_pages_unete_Motivation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82273);
/* harmony import */ var _components_head_meta__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23385);
/* harmony import */ var shared_models_const_keywords_const__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6644);
/* harmony import */ var _components_a1_refactor_typography_WsPhantomNav__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79001);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70917);










var Agentes = function Agentes() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  var metaData = {
    description: "join",
    keyWords: shared_models_const_keywords_const__WEBPACK_IMPORTED_MODULE_6__/* .CKeyWordsPages.join */ .k.join,
    title: "join",
    url: router.asPath,
    picture: "/images/image-optimize/happy-couple-with-keys-of-new-apartment.webp"
  };
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_head_meta__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, metaData), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_a1_refactor_typography_WsPhantomNav__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, null), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_pages_unete_JoinRemax__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, null), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_pages_unete_Statistic__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, null), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_pages_unete_Motivation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, null));
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Agentes);

/***/ }),

/***/ 40173:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agentes",
      function () {
        return __webpack_require__(32126);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3828,3913,8937,9774,2888,179], function() { return __webpack_exec__(40173); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);